module.exports = {
    LOG_OPERATIONS: {
        LLLT: 1,
        RF: 2,
        EMT: 3,
        ELASTICITY: 4,
        HUMIDITY: 5,
        SEBUM: 6,
        DOCTOR_ADVICE: 7,
        LOGIN: 8,
        LOGOUT: 9,
        CHANGE_PLAN: 11,
        CHANGE_USER_SKIN: 12,
        ASSIGN_DOCTOR: 16,
        NOTIFY: 17,
        DEVICE_ERROR: 18,
        REGISTER: 19,
        UPDATE_USER: 22,
        AGREEMENT_READ: 23,
        PRIVACY_READ: 24,
        CHANGE_UNIT: 25,
        SUBSCRIPTION: 27,
        CHANGE_DEFAULT: 29,
        GENERAL: 30,
        DEVICE_CONNECTED: 31,
        DEVICE_DISCONNECTED: 32,
        CHAT_WITH_DOCTOR: 33,
        MOBILE_SETTINGS_UPDATE: 34,
        FW_UPDATE: 35,
        MANUAL_READ: 36,
        EVENT: 37,
        CLIENT_THROUGHPUT: 38,
        PROCEDURE_LIFETIME_CREATE: 39
    },

    LOG_STATUS: {
        PASS: 1,
        FAIL: 2,
        CONFIRM: 3,
    },

    PLAN_REPEAT: {
        DAILY: 1,
        WEEKLY: 2,
        BIWEEKLY: 3,
        MONTHLY: 4,
        FREE: 5,
        NONE: 6,
    },

    PLAN_TYPE: {
        DOCTOR: 1,
        PATIENT: 2,
        DEFAULT: 3,
    },

    USER_TYPE: {
        PATIENT: 1,
        DOCTOR: 2,
        SUPER: 3,
        IT: 4,
        BEAUTY_ADVISOR: 5,
        TRANSLATOR: 6,
    },

    USER_GENDER: {
        MALE: 1,
        FEMALE: 2,
    },

    POLICY_TYPE: {
        JOLI_360_PRO_PRIVACY: 1,
        JOLI_360_PRO_EULA: 2,
        JOLI_360_PRO_MANUAL: 3,
    },

    PRODUCT_TYPE: {
        ACNE: 1,
        ANTI_AGING: 2,
        PIGMENTATION: 3,
    },

    TREATMENT_TYPE: {
        PATIENT: 1,
        DOCTOR: 2,
        DEFAULT: 3,
        FREE: 4,
    },

    POWER_LEVEL: {
        LOW: 1,
        MED: 2,
        HIGH: 3,
    },

    HANDLE_TYPE: {
        MEASUREMENT: 2,
        TREATMENT: 1,
    },

    ERROR_CODES: {
        MISSING_PARAMETERS: 422,
        WRONG_PARAMETERS: 422,
        HANDLE_EXCEEDED_MAX: 430,
        NO_AUTHENTICATION: 401,
        SERVER_ERROR: 500,
    },

    ERROR_MESSAGES: {
        MISSING_PARAMETERS: "Query parameters are missing",
        WRONG_FORMAT: "Query parameters are not in the currect format",
        SERVER_ERROR: "Server error",
        NO_TOKEN: "No authentication token",
        PASSWORD_CHANGE: "Password has expired",
        DATE_NOT_IN_FORMAT: "Date not in correct format",
        MONTH_YEAR_NOT_IN_FORMAT: "Month/Year field not in correct format(MM/YYYY)",
        ERROR: "An error has occurred",
        PASSWORD_ALREADY_USED: "Password has been used already, choose another.",
        EMAIL_ALREADY_USED: "Email address was already used",
        MOBILE_ALREADY_USED: "Mobile number was already used",
        NO_PERMISSIONS: "No permissions",
        INCORRECT_EMAIL_OR_PHONE: "Email or phone number aren't correct",
        MEASUREMENT_HANDLE_USED_MAX_TIMES: "Measurement handle exceeded max 3 times use",
        TREATMENT_HANDLE_USED_MAX_TIMES: "Treatment handle exceeded max 3 times use",
        USER_BANNED: "User is banned",
        WRONG_USER_TYPE: "Wrong user type",
        NO_ACCESS: "Requested resouce cannot be accessed",
        PASSWORD_REQUIREMENTS_INVALID: "PASSWORD DOESN'T MEET REQUIERMENTS",
    },

    getKeyByValue: function(object, value) {
        return Object.keys(object).find((key) => object[key] == value);
    },
};


// WEBPACK FOOTER //
// ./config/enums.js